import { PANGU_AUTH_ID_MAP } from './constant/common';

const menusList = [
  {
    name: '首页',
    isQqDomianCheck: true,
    checkAuth: [PANGU_AUTH_ID_MAP.view_all_sys_data],
    children: [
      {
        name: '数据管理',
        children: [
          {
            name: '整体数据',
            path: '/databoard',
            checkAuth: [PANGU_AUTH_ID_MAP.view_all_sys_data],
          },
          {
            name: '用户数据',
            path: '/databoard/mydata',
            checkAuth: [PANGU_AUTH_ID_MAP.view_all_sys_data],
          },
        ],
      },
    ],
  },
  {
    name: '语料管线',
    insert: true,
    checkAuth: [
      PANGU_AUTH_ID_MAP.corpus_pipeline_manage,
      PANGU_AUTH_ID_MAP.corpus_pipeline_project_manage,
      PANGU_AUTH_ID_MAP.corpus_pipeline_project_mark,
      PANGU_AUTH_ID_MAP.corpus_pipeline_project_review,
    ],
    children: [
      {
        name: '新增语料',
        checkAuth: [PANGU_AUTH_ID_MAP.corpus_pipeline_manage],
        children: [
          {
            name: '语料抓取任务',
            path: '/pipeline/crawl',
            checkAuth: [PANGU_AUTH_ID_MAP.corpus_pipeline_manage],
          },
          {
            name: '本地上传语料',
            path: '/pipeline/local-upload',
            checkAuth: [PANGU_AUTH_ID_MAP.corpus_pipeline_manage],
          },
          // {
          //   name: '线上回流语料',
          //   path: '/pipeline/online-return-flow',
          //   checkAuth: [PANGU_AUTH_ID_MAP.corpus_pipeline_manage],
          // },
        ],
      },
      {
        name: '语料数据管理',
        checkAuth: [PANGU_AUTH_ID_MAP.corpus_pipeline_manage],
        children: [
          {
            name: '语料集列表',
            path: '/pipeline/corpus-set-manage',
            checkAuth: [PANGU_AUTH_ID_MAP.corpus_pipeline_manage],
          },
          // {
          //   name: '语料血缘',
          //   path: '/pipeline/corpus-lineage',
          //   checkAuth: [PANGU_AUTH_ID_MAP.mark],
          // },
        ],
      },
      {
        name: '工具管理',
        checkAuth: [
          PANGU_AUTH_ID_MAP.corpus_pipeline_manage,
          PANGU_AUTH_ID_MAP.corpus_pipeline_project_manage,
          PANGU_AUTH_ID_MAP.corpus_pipeline_project_mark,
          PANGU_AUTH_ID_MAP.corpus_pipeline_project_review,
        ],
        children: [
          {
            name: '语料处理链路',
            path: '/pipeline/machine-common',
            checkAuth: [PANGU_AUTH_ID_MAP.corpus_pipeline_manage],
          },
          {
            name: '语料清洗任务',
            path: '/pipeline/corpus-cleaning',
            checkAuth: [PANGU_AUTH_ID_MAP.corpus_pipeline_manage],
          },
          {
            name: '语料修改任务',
            path: '/pipeline/machine-modification',
            checkAuth: [PANGU_AUTH_ID_MAP.corpus_pipeline_manage],
          },
          {
            name: '语料加工',
            path: '/pipeline/project-manage',
            checkAuth: [
              PANGU_AUTH_ID_MAP.corpus_pipeline_project_manage,
              PANGU_AUTH_ID_MAP.corpus_pipeline_project_mark,
              PANGU_AUTH_ID_MAP.corpus_pipeline_project_review,
            ],
          },
        ],
      },
    ],
  },
  {
    name: '生产评测',
    insert: true,
    checkAuth: [
      PANGU_AUTH_ID_MAP.create_project,
      PANGU_AUTH_ID_MAP.manage_project,
      PANGU_AUTH_ID_MAP.mark,
      PANGU_AUTH_ID_MAP.review,
      PANGU_AUTH_ID_MAP.sample,
      PANGU_AUTH_ID_MAP.check,
      PANGU_AUTH_ID_MAP.cai_blind_review,
      PANGU_AUTH_ID_MAP.tts_blind_review,
      PANGU_AUTH_ID_MAP.qa_review,
      PANGU_AUTH_ID_MAP.corpus_tts_blind_review,
      PANGU_AUTH_ID_MAP.corpus_tts_blind_review_manage,
      PANGU_AUTH_ID_MAP.corpus_tts_compared_review,
      PANGU_AUTH_ID_MAP.corpus_tts_compared_review_manage,
      PANGU_AUTH_ID_MAP.corpus_img_model_review,
      PANGU_AUTH_ID_MAP.corpus_img_model_review_manage,
      PANGU_AUTH_ID_MAP.h5_eval_review,
      PANGU_AUTH_ID_MAP.h5_eval_review_manage,
      PANGU_AUTH_ID_MAP.img_blind_review,
      PANGU_AUTH_ID_MAP.img_blind_review_manage,
    ],
    children: [
      {
        name: '评测管理',
        checkAuth: [
          PANGU_AUTH_ID_MAP.cai_blind_review,
          PANGU_AUTH_ID_MAP.tts_blind_review,
          PANGU_AUTH_ID_MAP.qa_review,
          PANGU_AUTH_ID_MAP.corpus_tts_blind_review,
          PANGU_AUTH_ID_MAP.corpus_tts_blind_review_manage,
          PANGU_AUTH_ID_MAP.corpus_tts_compared_review,
          PANGU_AUTH_ID_MAP.corpus_tts_compared_review_manage,
          PANGU_AUTH_ID_MAP.corpus_img_model_review,
          PANGU_AUTH_ID_MAP.corpus_img_model_review_manage,
          PANGU_AUTH_ID_MAP.h5_eval_review,
          PANGU_AUTH_ID_MAP.h5_eval_review_manage,
          PANGU_AUTH_ID_MAP.img_blind_review,
          PANGU_AUTH_ID_MAP.img_blind_review_manage,
        ],
        children: [
          {
            name: '模型盲评',
            path: '/review/cai_blind_review',
            checkAuth: [PANGU_AUTH_ID_MAP.cai_blind_review],
          },
          {
            name: '语音包盲评',
            path: '/review/tts_review',
            checkAuth: [PANGU_AUTH_ID_MAP.tts_blind_review],
          },
          {
            name: 'TTS盲评',
            path: '/review/corpus_tts_review',
            checkAuth: [PANGU_AUTH_ID_MAP.corpus_tts_blind_review, PANGU_AUTH_ID_MAP.corpus_tts_blind_review_manage],
          },
          {
            name: 'TTS对比评估',
            path: '/review/compared_tts_review',
            checkAuth: [
              PANGU_AUTH_ID_MAP.corpus_tts_compared_review,
              PANGU_AUTH_ID_MAP.corpus_tts_compared_review_manage,
            ],
          },
          {
            name: '图片模型横评',
            path: '/review/img_model_review',
            checkAuth: [PANGU_AUTH_ID_MAP.corpus_img_model_review, PANGU_AUTH_ID_MAP.corpus_img_model_review_manage],
          },
          {
            name: '图片盲评',
            path: '/review/img_review',
            checkAuth: [PANGU_AUTH_ID_MAP.img_blind_review, PANGU_AUTH_ID_MAP.img_blind_review_manage],
          },
          {
            name: 'H5 对话评估',
            path: '/review/h5_bot_chat_review',
            checkAuth: [PANGU_AUTH_ID_MAP.h5_eval_review, PANGU_AUTH_ID_MAP.h5_eval_review_manage],
          },
        ],
      },
      {
        name: '语料生产',
        checkAuth: [
          PANGU_AUTH_ID_MAP.create_project,
          PANGU_AUTH_ID_MAP.manage_project,
          PANGU_AUTH_ID_MAP.mark,
          PANGU_AUTH_ID_MAP.review,
          PANGU_AUTH_ID_MAP.sample,
          PANGU_AUTH_ID_MAP.check,
        ],
        children: [
          {
            name: '项目列表',
            path: '/corpus_upgraded/project',
            checkAuth: [
              PANGU_AUTH_ID_MAP.create_project,
              PANGU_AUTH_ID_MAP.manage_project,
              PANGU_AUTH_ID_MAP.mark,
              PANGU_AUTH_ID_MAP.review,
              PANGU_AUTH_ID_MAP.sample,
              PANGU_AUTH_ID_MAP.check,
            ],
          },
          {
            name: '任务列表',
            path: '/corpus_upgraded/task',
            checkAuth: [
              PANGU_AUTH_ID_MAP.create_project,
              PANGU_AUTH_ID_MAP.manage_project,
              PANGU_AUTH_ID_MAP.mark,
              PANGU_AUTH_ID_MAP.review,
              PANGU_AUTH_ID_MAP.sample,
              PANGU_AUTH_ID_MAP.check,
            ],
            isShow: false,
          },
          {
            name: 'QA列表',
            path: '/corpus_upgraded/qa',
            checkAuth: [
              PANGU_AUTH_ID_MAP.create_project,
              PANGU_AUTH_ID_MAP.manage_project,
              PANGU_AUTH_ID_MAP.mark,
              PANGU_AUTH_ID_MAP.review,
              PANGU_AUTH_ID_MAP.sample,
              PANGU_AUTH_ID_MAP.check,
            ],
            isShow: false,
          },
          {
            name: '模板管理',
            path: '/corpus_upgraded/template',
            checkAuth: [PANGU_AUTH_ID_MAP.template_manage],
          },
        ],
      },
      {
        name: '图片管理',
        checkAuth: [PANGU_AUTH_ID_MAP.image_manage, PANGU_AUTH_ID_MAP.image_reflow_marking],
        children: [
          // {
          //   name: '生图日志打标',
          //   path: '/image_manage/reflow_log_marking',
          //   checkAuth: [PANGU_AUTH_ID_MAP.image_reflow_marking],
          // },
          {
            name: '垫图语料',
            path: '/image_manage/padding',
            checkAuth: [PANGU_AUTH_ID_MAP.image_manage],
          },
        ],
      },
    ],
  },
  {
    name: '工具管理',
    isQqDomianCheck: true,
    children: [
      {
        name: '账号体系',
        checkAuth: [PANGU_AUTH_ID_MAP.approve_auth],
        children: [
          {
            name: '权限审批',
            path: '/account/approve',
          },
        ],
      },
    ],
  },
];
export default menusList;
export interface MenuItem {
  name: string;
  path?: string;
  description?: string;
  children?: MenuItem[];
  width?: number;
  disabled?: boolean;
}
